import { render, staticRenderFns } from "./CompanyTypeModalForm.vue?vue&type=template&id=c8d3ca3a"
import script from "./CompanyTypeModalForm.vue?vue&type=script&lang=js"
export * from "./CompanyTypeModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports